import React, { useState } from 'react'
import { Button, Dropdown, Modal } from 'react-bootstrap'
import { IPartnerEmployee } from '../../../types/partners/IPartnerEmployee'
import {VacancyCompanyHook} from "../../../api/vacancy-company/vacancy-company.api";
import {toast} from "react-toastify";

type Props = {
  companyId: number,
  employee: IPartnerEmployee,
  update: () => void
  id: number
}

const UnAssignUser = (props: Props) => {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  }
  const {
    companyId, employee, update, id
  } = props
  const { mutate: unAssignMutate } = VacancyCompanyHook.useUnAssignEmployee()

  const handleUnssign = async () => {
    unAssignMutate(
      { companyId: id, userId: employee.id, vacancyCompanyId: companyId },
      {
        onSuccess: () => {
          toast.success("Сотрудник успешно откреплен!");
          update();
          handleClose();
        },
        onError: (error) => {
          toast.error("Ошибка при откреплении сотрудника: " + (error?.message || "Неизвестная ошибка"));
        },
      }
    );
  };


  return (
    <>
      <Dropdown.Item onClick={handleShow}>Открепить сотрудника от заказчика</Dropdown.Item>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Открепление сотрудника от заказчика</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-danger'>Вы уверены, что хотите открепить сотрудника от заказчика?</p>
          <p><small>Сотрудника можно перекрепить заново</small></p>

          <Button variant={'danger'} onClick={handleUnssign}>Открепить</Button>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UnAssignUser